module.exports = __webpack_public_path__ + "static/union-square-poster-d0498b8a8d80e6b201f6153cea2d1c1a.jpg";